import { render } from "./SyncElementNotUsedTemplates.vue?vue&type=template&id=2986fd5c&scoped=true"
import script from "./SyncElementNotUsedTemplates.vue?vue&type=script&lang=ts"
export * from "./SyncElementNotUsedTemplates.vue?vue&type=script&lang=ts"

import "./SyncElementNotUsedTemplates.vue?vue&type=style&index=0&id=2986fd5c&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-2986fd5c"

export default script